const model = {
    statusTypeDetails: null,
    loading: false,
    error: null,
};

export default model;